namespace GeniuzPOS.InitialData {
    export interface PsPanelGroupButtonRow {
        Id?: number;
        TouchPanelType?: string;
        GroupButtonId?: number;
        GroupButtonLabel?: string;
        GroupButtonImage?: string;
        BgColor?: string;
        TxtColor?: string;
        TxtFontSize?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        DtList?: PsPanelItemButtonRow[];
    }

    export namespace PsPanelGroupButtonRow {
        export const idProperty = 'Id';
        export const nameProperty = 'GroupButtonLabel';
        export const localTextPrefix = 'InitialData.PsPanelGroupButton';
        export const lookupKey = 'InitialData.PsPanelGroupButton';

        export function getLookup(): Q.Lookup<PsPanelGroupButtonRow> {
            return Q.getLookup<PsPanelGroupButtonRow>('InitialData.PsPanelGroupButton');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:แบบหน้าจอปุ่มกด:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:แบบหน้าจอปุ่มกด:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:แบบหน้าจอปุ่มกด:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:แบบหน้าจอปุ่มกด:Modify';

        export declare const enum Fields {
            Id = "Id",
            TouchPanelType = "TouchPanelType",
            GroupButtonId = "GroupButtonId",
            GroupButtonLabel = "GroupButtonLabel",
            GroupButtonImage = "GroupButtonImage",
            BgColor = "BgColor",
            TxtColor = "TxtColor",
            TxtFontSize = "TxtFontSize",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            DtList = "DtList"
        }
    }
}
